import React, { Component } from 'react';
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Row } from 'reactstrap';

class DTCRepromptLastName extends Component {
  render() {
    return (
      <div className="page-preapproved narrow">
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6} className="text-center mb-2 mt-2 mt-md-4">
              <img src="/icons/declined.svg" alt="Pro-Approved" className="mb-3" />
              <h1 className="mb-4">We had a difficult time verifying you</h1>
              <Row>
                <Col sm={{size: 8, offset: 2}} md={{size: 10, offset: 1}} lg={{size: 8, offset: 2}}>
                  <Card className="dark-shadow">
                    <CardBody>
                      <h4 className="mb-3">Please Re-enter Your Last Name</h4>
                      <Form>
                        <FormGroup className="input-inline">
                          <Input type="text" name="last-name" id="LastName" placeholder="Last Name" />
                        </FormGroup>
                        <Button color="primary" size="lg" className="w-100">Submit</Button>
                      </Form>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </div>
    )
  }
}

export default DTCRepromptLastName;
